// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_container {
  text-align: center;
}

div [mat-dialog-title] {
  display: flex;
  justify-content: center;
}

mat-dialog-actions {
  justify-content: center;
  margin: 12px 0 0 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/dialogs/application-dialog/application-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;AACJ;;AAEA;EACI,uBAAA;EACA,kBAAA;AACJ","sourcesContent":[".dialog_container {\r\n    text-align: center;\r\n}\r\n\r\ndiv [mat-dialog-title] {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\nmat-dialog-actions {\r\n    justify-content: center;\r\n    margin: 12px 0 0 0 ;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
